import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cms-top-bar',
  templateUrl: './cms-top-bar.component.html',
  styleUrls: ['./cms-top-bar.component.scss']
})
export class CmsTopBarComponent implements OnInit {

  constructor() { }

  auth_data:any;

  ngOnInit(): void {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
  }

  logOut(){
    localStorage.removeItem('access_token');
    window.location.href = "./"
  }
}
